import { Container, Grid, InputAdornment, Paper, Table, TableRow, TableBody, TableCell, TableContainer, TableHead, TextField, Typography, LinearProgress, Hidden } from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import PageHeader from "../components/PageHeader";
import { useTranslation } from "react-i18next";
import { Search } from "@material-ui/icons";
import { useHistory, useParams, Redirect } from "react-router-dom";
import * as ROUTES from "../constants/routes";
import AddUser from "../components/AddUser";
import { withAuthorization, AuthUserContext } from "../components/Session";
import * as DATANETAPI from "../components/DataNet/DataNet";
import { hasPermission } from "../functions/authorization";
import { USERS_SELECT, USERS_ADD } from "../constants/roles";

const UsersPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { programId, groupId } = useParams();

  const [inputText, setinputText] = useState("");
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersBack, setUsersBack] = useState([]);
  const [areUsersLoaded, setAreUsersLoaded] = useState(false);

  const normalizeSearchValue = (value) =>
    (value ?? "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase();

  const getUserSearchText = (user) => {
    const groupNames = (user.groups || [])
      .map((group) => group?.name || group)
      .join(" ");

    return normalizeSearchValue([
      user.email,
      user.name,
      user.last_name,
      user.lastname,
      user.telephone,
      groupNames,
    ].join(" "));
  };

  const filterUsers = (text, sourceUsers) => {
    const normalizedText = normalizeSearchValue(text);

    if (!normalizedText) {
      return sourceUsers;
    }

    return sourceUsers.filter((user) =>
      getUserSearchText(user).includes(normalizedText)
    );
  };

  const searchHandler = (event) => {
    const value = event.target.value;

    setinputText(value);
    setUsers(filterUsers(value, usersBack));
  };

  useEffect(() => {
    setAreUsersLoaded(false);
    setinputText("");
    
    DATANETAPI.getUsers(programId, groupId).then((snap) => {
      if (snap?.status === 1 && Array.isArray(snap.data)) {
        const uniqueUsers = Object.values(
          snap.data.reduce((acc, user) => {
            acc[user.id] = user;
            return acc;
          }, {})
        );

        setUsersBack(uniqueUsers);
        setUsers(uniqueUsers);
      } else {
        setUsersBack([]);
        setUsers([]);
      }

      setAreUsersLoaded(true);
    });
  }, [programId, groupId]);

  return (
    <AuthUserContext.Consumer>
      {(authUser) => {
        const canViewUsers = hasPermission(authUser, USERS_SELECT);
        const canAddUser = hasPermission(authUser, USERS_ADD);

        if (!canViewUsers) {
          return <Redirect to={ROUTES.HOME} />;
        }

        return (
          <Container>
            <Grid container spacing={2} direction="column">
              <Grid item>
                <PageHeader title={t("users.title")} />
              </Grid>

              <Grid item>
                <Paper style={{ padding: 12 }}>
                  <Grid container direction="row" alignItems="center">
                    <Grid item container alignItems="center" xs={6} justify="flex-start">
                      <Grid item>
                        <TextField
                          label={t("common.search")}
                          value={inputText}
                          onChange={searchHandler}
                          margin="dense"
                          placeholder={t("common.search")}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Search />
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={6} container justify="flex-end">
                      <Grid item>
                        <AddUser open={addModalOpen} handleClose={setAddModalOpen} disabled={!canAddUser} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid item>
                <TableContainer component={Paper}>
                  {!areUsersLoaded && <LinearProgress />}

                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell width={64}>{t("users.table.email")}</TableCell>
                        <TableCell align="center">{t("users.table.name")}</TableCell>
                        <Hidden smDown>
                          <TableCell align="center">{t("users.table.last_name")}</TableCell>
                        </Hidden>
                        <Hidden smDown>
                          <TableCell align="center">{t("users.table.telephone")}</TableCell>
                        </Hidden>
                        <Hidden smDown>
                          <TableCell align="right">{t("users.table.groups")}</TableCell>
                        </Hidden>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {users.map((row) => (
                        <TableRow
                          hover
                          key={row.id}
                          onClick={() => {
                            history.push(ROUTES.USER + "/" + row.id);
                            window.scrollTo(0, 0);
                          }}
                        >
                          <TableCell component="th" scope="row" align="left">
                            <Hidden smDown>
                              <Typography variant="body1" style={{ fontWeight: 500 }}>
                                {row.email}
                              </Typography>
                            </Hidden>
                            <Hidden mdUp>
                              <Typography variant="body1">{`${row.email}`}</Typography>
                            </Hidden>
                          </TableCell>

                          <TableCell align="center">{row.name}</TableCell>

                          <Hidden smDown>
                            <TableCell align="center">{row.last_name}</TableCell>
                          </Hidden>
                          <Hidden smDown>
                            <TableCell align="center">{row.telephone}</TableCell>
                          </Hidden>
                          <Hidden smDown>
                            <TableCell align="right">{(row.groups || []).map((g, i) => i !== row.groups.length - 1 ? g.name + " · " : g.name)}</TableCell>
                          </Hidden>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {users.length === 0 && areUsersLoaded && (
                    <Grid container justify="center" alignContent="center" style={{ height: 120 }}>
                      <Typography variant="h4" color="textSecondary">
                        {t("users.notFound")}
                      </Typography>
                    </Grid>
                  )}
                </TableContainer>
              </Grid>
            </Grid>
          </Container>
        );
      }}
    </AuthUserContext.Consumer>
  );
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(UsersPage);

var usersBack = [
  {
    id: 10,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["c"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 11,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 12,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["a"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 13,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 14,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 15,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 16,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 17,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 18,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 19,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 20,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["c"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
  {
    id: 21,
    email: "argiosa@bexencardio.com",
    name: "Argi",
    last_name: "Osa",
    roles: ["u"],
    telephone: "+34 698542154",
    groups: ["Ermua Centro"],
  },
];